
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -22 72 72"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M41.172.879c-1.426.747-1.957 2.009-1.957 5.494 0 0 .722-.698 1.793-1.087a7.591 7.591 0 001.833-.995c1.205-.883 1.392-2.02 1.392-3.933 0 0-1.965-.053-3.061.52m-8.457.817c-1.163 1.025-1.503 2.659-1.503 2.659l-3.85 14.917L24.16 7.062c-.312-1.298-.874-2.902-1.764-3.987-1.133-1.382-3.436-1.469-3.681-1.469-.246 0-2.55.087-3.683 1.469-.89 1.085-1.451 2.689-1.763 3.987l-3.202 12.209L6.216 4.354s-.34-1.634-1.502-2.659C2.828.033 0 .388 0 .388l7.373 27.877s2.432.176 3.65-.445c1.598-.814 2.359-1.443 3.327-5.236.862-3.382 3.273-13.315 3.498-14.022.112-.349.253-1.184.867-1.184.626 0 .756.834.865 1.184.22.708 2.636 10.64 3.499 14.022.968 3.793 1.728 4.422 3.327 5.236 1.217.621 3.649.445 3.649.445L37.428.388S34.6.033 32.715 1.695M44.23 4.939s-.46.714-1.513 1.302c-.675.378-1.325.634-2.02.968-1.166.56-1.483 1.182-1.483 2.132v18.924s1.861.236 3.078-.385c1.566-.798 1.926-1.568 1.94-5.035V5.95l-.002.001V4.94zm18.378 9.455L71.963.48s-3.948-.672-5.903 1.107c-1.25 1.14-2.65 3.187-2.65 3.187l-3.442 4.962c-.167.258-.386.54-.735.54s-.567-.282-.734-.54l-3.442-4.962s-1.399-2.048-2.65-3.187C50.452-.192 46.504.48 46.504.48l9.354 13.914-9.33 13.871s4.112.52 6.067-1.26c1.251-1.139 2.462-2.99 2.462-2.99l3.442-4.962c.167-.259.385-.539.734-.539.35 0 .568.28.735.54l3.442 4.96s1.281 1.852 2.532 2.99c1.956 1.781 5.996 1.261 5.996 1.261l-9.33-13.87z"}})])
          )
        }
      }
    